import classNames from 'classnames';
import { Outlet, useLocation } from 'react-router-dom';

import { AuthFrame, ConsentFrame } from '@/eyre/Frame';
import { layoutClassNames } from '@/utils/consts';

import styles from './index.module.scss';

// Eyre ID: the consent page gets the Google-style card, every other page the ChatGPT-style column
// (plain or split, per /eyre-brand/ui.json). Logto's centered card and signature are not rendered.
const AppLayout = () => {
  const { pathname } = useLocation();
  const Frame = pathname.startsWith('/consent') ? ConsentFrame : AuthFrame;

  return (
    <div className={classNames(styles.viewBox, layoutClassNames.pageContainer)}>
      <Frame>
        <div className={classNames(styles.main, layoutClassNames.mainContent)}>
          <Outlet />
        </div>
      </Frame>
    </div>
  );
};

export default AppLayout;
